export default {
  '401': '認証に失敗し、アクセスできません。',
  '403': '現在の操作には権限がありません',
  '404': 'アクセスするリソースが存在しません',
  // ダッシュボード劇場ランキング（/dp/cinemaRank 系）の業務エラーコード。
  // バックエンドは msg に安定した文字列コード（MOVIE_NOT_FOUND 等）を返すため、
  // ここで日本語表示に読み替える。未定義なら msg（コード文字列）がそのまま出る。
  '40001': 'ページング情報の有効期限が切れました。最初から読み込み直します。',
  '40002': '検索条件が正しくありません',
  '40401': '作品が見つかりません',
  '40402': 'この劇場では該当作品の上映実績がありません',
  '50301': 'データを取得できませんでした。しばらくしてから再度お試しください。',
  'default': '不明なシステムエラーです。管理者にお問い合わせください。',
};
